import { getPaginated } from '@/api/base'

export const getManualValues = async (containerUuid, paginationOptions) => {
  const { values } = await getPaginated({
    path: `containers/${containerUuid}/manual_values`,
    valuePath: 'container_manual_values',
    ...paginationOptions,
  })

  return values
}
